import axiosService from './common/axios'
import Cookies from 'js-cookie'

/**
 * access log 생성
 *
 * @returns {*}
 */
export function access(url = window.location.href) {
  const tokenName = 'mcst-user-token';

  return axiosService.post('log/access', {
    userToken: Cookies.get(tokenName),
    accessUrl: url
  }).then(token => {
    Cookies.set(tokenName, token);
    return token;
  })
}
